import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import store from './store';
import { unregister } from './registerServiceWorker';
import { setupBuildNumberTimer } from './helpers/build_number_timer';

ReactDOM.render(
  <App
    store={store}
  />, document.getElementById('root'),
);

unregister();
setupBuildNumberTimer(store);



// WEBPACK FOOTER //
// ./src/index.js